import { EnvironmentType, MerchantType } from "@/enums/enums";
import { i18n } from "@/i18n";

export function NewObject(obj: any) {
  if (obj) {
    return JSON.parse(JSON.stringify(obj));
  } else {
    return obj;
  }
}
export function CheckIsDevelop() {
  return process.env.VUE_APP_TYPE_ENV <= EnvironmentType.SIT;
}
export function CheckIsMUZE() {
  return process.env.VUE_APP_Is_MUZE == 1;
}
export function GetMerchantNameWihtMerchantType(merchantType: number, merchantName: string) {
  let merchantFullName: any = "";
  switch (merchantType) {
    case MerchantType.LimitedLiabilityPartnership:
      merchantFullName = i18n.t("MerchantType.LimitedLiabilityPartnership", { name: merchantName });
      break;
    case MerchantType.Association:
      merchantFullName = i18n.t("MerchantType.Association", { name: merchantName });
      break;
    case MerchantType.JointVenture:
      merchantFullName = i18n.t("MerchantType.JointVenture", { name: merchantName });
      break;
    case MerchantType.CompanyLimited:
      merchantFullName = i18n.t("MerchantType.CompanyLimited", { name: merchantName });
      break;
    case MerchantType.PublicCompanyLimited:
      merchantFullName = i18n.t("MerchantType.PublicCompanyLimited", { name: merchantName });
      break;
    case MerchantType.Shop:
      merchantFullName = i18n.t("MerchantType.Shop", { name: merchantName });
      break;
    case MerchantType.OrdinaryPerson:
      merchantFullName = i18n.t("MerchantType.OrdinaryPerson", { name: merchantName });
      break;
    case MerchantType.BodyOfPersons:
      merchantFullName = i18n.t("MerchantType.BodyOfPersons", { name: merchantName });
      break;
    case MerchantType.Others:
      merchantFullName = i18n.t("MerchantType.Others", { name: merchantName });
      break;
    case MerchantType.OrdinaryPartnership:
      merchantFullName = i18n.t("MerchantType.OrdinaryPartnership", { name: merchantName });
      break;
    case MerchantType.Foundation:
      merchantFullName = i18n.t("MerchantType.Foundation", { name: merchantName });
      break;
  }
  return merchantFullName;
}
export function CheckTextTooLong(numberCharacter: number, limitNumberCharacter: number) {
  return numberCharacter > limitNumberCharacter;
}
export function DecodeJwtResponse(credential: any) {
  return JSON.parse(atob(credential.split(".")[1]).toString());
}

function DetectTabClosing(e: any) {
  const confirmationMessage = "";

  (e || window.event).returnValue = confirmationMessage;
  return confirmationMessage;
}

export function AddDetectTabClosing() {
  window.addEventListener("beforeunload", DetectTabClosing);
}
export function RemoveDetectTabClosing() {
  window.removeEventListener("beforeunload", DetectTabClosing);
}

export function UnsetOverflowModalBox(unsetOverflow: boolean) {
  const elementIdList = document.querySelectorAll("[id='modalBox']");

  if (elementIdList.length > 0) {
    elementIdList.forEach((elementId) => {
      let element = null;
      element = elementId.getElementsByClassName("modalBox")[0];
      if (element) {
        if (unsetOverflow) {
          element.classList.add("unsetOverflow");
          element.classList.add("isCanNotRemoveCalss");
          setTimeout(() => {
            const elementModalBox = elementId.getElementsByClassName("modalBox")[0];
            elementModalBox.classList.remove("isCanNotRemoveCalss");
          }, 500);
        } else {
          if (!element.classList.contains("isCanNotRemoveCalss")) {
            element.classList.remove("unsetOverflow");
          }
        }
      }
    });
  }
}
